// src/views/Dashboard/Repositories/Opcao2.js
import React, { useState } from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Button,
  useColorMode,
  Flex,
  Avatar,
  Input,
  IconButton,
  Checkbox,
  useColorModeValue,
  Stack, // Adicionado aqui
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

function Opcao2() {
  const { colorMode } = useColorMode();
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const [selectedEmails, setSelectedEmails] = useState([]);

  // Dados fictícios de emails
  const emails = [
    {
      id: 1,
      sender: 'Marco Maximiliano',
      subject: 'Férias Aprovadas',
      date: '2024-10-01',
      content: 'Vinicius Suas férias foram aprovadas...',
    },
    {
      id: 2,
      sender: 'Professor Lucas',
      subject: 'Curso de Gratis',
      date: '2024-09-01',
      content: 'Estou ministrando curso gratuito para coleguinhas',
    },
    {
      id: 3,
      sender: 'Vinicius Aragão',
      subject: 'Pastel feito na hora',
      date: '2024-08-01',
      content: 'Vendo pastél mais barato',
    },
    {
      id: 4,
      sender: 'Makoto',
      subject: 'Lista de vendas do Japonês',
      date: '2024-10-05',
      content: 'Hiphone 3 Chips sistema Android/ Tadalafila de 5mg é R$ 10',
    },  
  ];

  // Função para filtrar os e-mails com base nos critérios
  const getFilteredEmails = () => {
    return emails.filter((email) => {
      const matchesSearch =
        email.sender.toLowerCase().includes(searchTerm.toLowerCase()) ||
        email.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
        email.content.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesDate = filterDate ? email.date === filterDate : true;

      return matchesSearch && matchesDate;
    });
  };

  const filteredEmails = getFilteredEmails();

  // Função para lidar com a seleção de e-mails
  const handleEmailSelect = (emailId) => {
    setSelectedEmails((prev) => {
      if (prev.includes(emailId)) {
        return prev.filter((id) => id !== emailId);
      } else {
        return [...prev, emailId];
      }
    });
  };

  // Função para verificar se algum e-mail foi selecionado
  const isReprocessEnabled = selectedEmails.length > 0;

  return (
    <Flex
      direction="row"
      height="80vh"
      p={4}
      bg={useColorModeValue('gray.50', 'gray.800')}
      borderRadius="md"
      boxShadow="md"
    >
      {/* Lista de e-mails à esquerda */}
      <Box
        width="35%"
        p={4}
        bg={useColorModeValue('gray.100', 'gray.700')}
        borderRadius="md"
        boxShadow="md"
        overflowY="auto"
      >


        {/* Campo de Filtro */}
        <Box mb={4}>
          <VStack spacing={3} align="stretch">
            {/* Campo de Pesquisa */}
            <HStack>
              <Input
                placeholder="Pesquisar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="sm"
              />
              <IconButton
                aria-label="Pesquisar"
                icon={<SearchIcon />}
                size="sm"
                onClick={() => {}}
              />
            </HStack>

            {/* Filtro por Data */}
            <Input
              type="date"
              placeholder="Filtrar por Data"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              size="sm"
            />
          </VStack>
        </Box>

        {/* Botão Reprocessar */}
        <Button
          colorScheme="blue"
          size="sm"
          mb={4}
          disabled={!isReprocessEnabled}
          onClick={() => alert('Reprocessando e-mails selecionados...')}
        >
          Reprocessar
        </Button>

        {/* Lista de E-mails Filtrados */}
        <VStack align="stretch" spacing={3}>
          {filteredEmails.length > 0 ? (
            filteredEmails.map((email) => (
              <HStack
                key={email.id}
                p={3}
                bg={
                  selectedEmail?.id === email.id
                    ? useColorModeValue('blue.100', 'blue.700')
                    : 'transparent'
                }
                borderRadius="md"
                boxShadow={
                  selectedEmail?.id === email.id ? 'sm' : 'none'
                }
                cursor="pointer"
                onClick={() => setSelectedEmail(email)}
                _hover={{ bg: useColorModeValue('blue.50', 'blue.600') }}
              >
                <Checkbox
                  isChecked={selectedEmails.includes(email.id)}
                  onChange={() => handleEmailSelect(email.id)}
                />
                <Avatar name={email.sender} size="sm" />
                <Box>
                  <Text
                    fontWeight="bold"
                    color={useColorModeValue('black', 'white')}
                  >
                    {email.sender}
                  </Text>
                  <Text
                    fontSize="sm"
                    color={useColorModeValue('gray.600', 'gray.300')}
                  >
                    {email.subject}
                  </Text>
                  <Text
                    fontSize="xs"
                    color={useColorModeValue('gray.500', 'gray.400')}
                  >
                    {new Date(email.date).toLocaleDateString()}
                  </Text>
                </Box>
              </HStack>
            ))
          ) : (
            <Text
              color={useColorModeValue('gray.500', 'gray.300')}
              textAlign="center"
            >
              Nenhum e-mail encontrado.
            </Text>
          )}
        </VStack>
      </Box>

      {/* Conteúdo do e-mail à direita */}
      <Box
        flex="1"
        p={4}
        bg={useColorModeValue('white', 'gray.700')}
        borderRadius="md"
        boxShadow="md"
        ml={4}
        overflowY="auto"
      >
        {selectedEmail ? (
          <Stack spacing={4}>
            <Text fontSize="2xl" fontWeight="bold">
              {selectedEmail.subject}
            </Text>
            <HStack>
              <Avatar name={selectedEmail.sender} size="sm" />
              <Text fontWeight="bold">{selectedEmail.sender}</Text>
              <Text
                fontSize="sm"
                color={useColorModeValue('gray.600', 'gray.400')}
              >
                {new Date(selectedEmail.date).toLocaleDateString()}
              </Text>
            </HStack>
            <Box mt={4}>
              <Text>{selectedEmail.content}</Text>
            </Box>
          </Stack>
        ) : (
          <Flex align="center" justify="center" height="100%">
            <Text
              color={useColorModeValue('gray.500', 'gray.300')}
              fontSize="lg"
            >
              Selecione um e-mail para visualizar seu conteúdo.
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  );
}

export default Opcao2;
